"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.2.4'] && _();
}
catch (e) { }
